import React from 'react';
import Dashboards from "../components/dashboards";

const DashboardsDomain = props =>
  <Dashboards {...props}/>;

export default DashboardsDomain;